import { Clipboard } from "@capacitor/clipboard";
import { useEffect, useState } from "react";

const useCopyToClipboard = (value: string | null) => {
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    if (showTooltip) {
      const tooltipTimeout = setTimeout(() => setShowTooltip(false), 1500);
      return () => {
        clearTimeout(tooltipTimeout);
      };
    }
  }, [showTooltip]);

  const handleCopyToClipboard = () => {
    if (value) {
      Clipboard.write({ string: value }).then(() => {
        setShowTooltip(true);
      });
    }
  };

  return {
    handleCopyToClipboard,
    showTooltip
  };
};

export default useCopyToClipboard;
